import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
    paperPlane,
    plane,
    spaceShip,
} from '../../assets/images'
import { IconDeviceDesktop, IconUser } from '@tabler/icons-react'
import { IconPrinter } from '@tabler/icons-react'

export default function Pricing() {

    const pricingOption1 = [
        {
            title: "Start",
            price: "$199",
            duration: "per month",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
        {
            title: "Good",
            price: "$299",
            duration: "per month",
            buttonLabel: "Join Now",
            popular: true,
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
        {
            title: "Ultima",
            price: "$399",
            duration: "per month",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
        {
            title: "Vip",
            price: "$799",
            duration: "per month",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
    ]

    const pricingOption2 = [
        {
            image: paperPlane,
            title: "Start",
            price: "Free",
            buttonLabel: "Sign Up",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
        {
            image: plane,
            title: "Good",
            price: "$149",
            buttonLabel: "Join Now",
            popular: true,
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
        {
            image: spaceShip,
            title: "Ultima",
            price: "$349",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
    ]

    const pricingOption3 = [
        {
            icon: IconDeviceDesktop,
            title: "Ui design",
            price: "149",
            currency: "$",
            buttonLabel: "Purchase Now",
            children: [
                {
                    option: ".PSD .AI .PNG .SVG",
                },
                {
                    option: "Licensed for 1 project",
                },
            ],
        },
        {
            icon: IconUser,
            title: "Ui design",
            price: "149",
            currency: "$",
            buttonLabel: "Purchase Now",
            children: [
                {
                    option: ".PSD .AI .PNG .SVG",
                },
                {
                    option: "Licensed for 1 project",
                },
            ],
        },
        {
            icon: IconPrinter,
            title: "Ui design",
            price: "149",
            currency: "$",
            buttonLabel: "Purchase Now",
            children: [
                {
                    option: ".PSD .AI .PNG .SVG",
                },
                {
                    option: "Licensed for 1 project",
                },
            ],
        },
    ]

    return (
        <>
            <Breadcrumb title="Pricing" path="Pages / Pricing" />
            <div className='mb-30'>
                <div className='text-[16px]/[20px] font-medium pb-10 mb-20 border-b border-border'>
                    Pricing Option 1
                </div>
                <div className='grid lg:grid-cols-4 md:gap-30 gap-20'>
                    {pricingOption1.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 text-center'>
                            <div className={`text-[32px]/[48px] font-medium p-20 ${item.popular ? 'text-blue' : ''}`}>
                                {item.title}
                            </div>
                            {item.children.map((res, key) => (
                                <div key={key}>
                                    <div className='border-t border-border p-15'>
                                        {res.option}
                                    </div>
                                </div>
                            ))}
                            <div className='border-t border-border py-30 px-15'>
                                <div className={`text-[36px]/[43.2px] font-medium ${item.popular ? 'text-blue' : ''}`}>
                                    {item.price}
                                </div>
                                <div className='text-text-secondary'>
                                    {item.duration}
                                </div>
                            </div>
                            <div className='border-t border-border p-20'>
                                <button className={`btn ${item.popular ? 'btn-blue' : 'btn-outline-secondary'}`}>
                                    {item.buttonLabel}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='mb-30'>
                <div className='text-[16px]/[20px] font-medium pb-10 mb-20 border-b border-border'>
                    Pricing Option 2
                </div>
                <div className='grid md:grid-cols-3 md:gap-30 gap-20'>
                    {pricingOption2.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light lg:p-20 p-15 text-center'>
                            <div className='p-20'>
                                <img src={item.image} alt='pricing' width="180" height="180" className='w-[180px] h-[180px] object-cover rounded-full mx-auto' />
                            </div>
                            <div className="text-[32px]/[48px] font-medium p-20 text-text-secondary">
                                {item.title}
                            </div>
                            {item.children.map((res, key) => (
                                <div key={key} className='text-[14px]/[30px] tracking-[1px]'>
                                    {res.option}
                                </div>
                            ))}
                            <div className={`text-[36px]/[43.2px] font-medium p-20 ${item.popular ? 'text-blue' : ''}`}>
                                {item.price}
                            </div>
                            <div className='pb-20'>
                                <button className={`btn ${item.popular ? 'btn-blue' : 'btn-outline-blue'}`}>
                                    {item.buttonLabel}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className=''>
                <div className='text-[16px]/[20px] font-medium pb-10 mb-20 border-b border-border'>
                    Pricing Option 3
                </div>
                <div className='grid md:grid-cols-3 md:gap-30 gap-20'>
                    {pricingOption3.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light lg:p-20 p-15 text-center'>
                            <div className='text-[20px]/[24px] font-medium p-20 border-b border-border'>
                                <item.icon className='w-[60px] h-[60px] mx-auto stroke-[1.5] mb-5' />
                                {item.title}
                            </div>
                            <div className='p-20'>
                                <div className='text-[16px]/[19.2px] font-medium mb-10'>
                                    Files
                                </div>
                                {item.children.map((res, key) => (
                                    <div key={key}>
                                        {res.option}
                                    </div>
                                ))}
                            </div>
                            <div className='text-[32px]/[48px] font-medium pb-20'>
                                {item.price}
                                <sup className='text-[50%] top-[-1rem] ml-5'>{item.currency}</sup>
                            </div>
                            <div className='pb-20'>
                                <button className='btn btn-outline-secondary'>
                                    {item.buttonLabel}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
